export enum DocumentVisibility {
  InternAndContractors = 'affinis_documentvisibility-100000001',
  Public = 'affinis_documentvisibility-100000002',
}
